import { css, SerializedStyles } from '@emotion/react';

export const STATIC_STYLES: SerializedStyles = css`
    /* Dot sizes */
    --carousel-dot-size: 8px;
    --carousel-dot-margin: 4px;
    --carousel-dot-size-small: calc(var(--carousel-dot-size) / 2);
    --carousel-dot-width: calc(var(--carousel-dot-size) + var(--carousel-dot-margin) * 2);
    --carousel-dot-margin-small: calc((var(--carousel-dot-width) - var(--carousel-dot-size-small)) / 2);
    --carousel-dots-height: calc(var(--carousel-dot-width) + (var(--carousel-dot-margin) * 2));

    /* Transitions */
    --carousel-dots-transition-duration: 200ms;

    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    height: var(--carousel-dots-height);
    position: relative;
    overflow: hidden;
    align-items: center;
    border-radius: calc(var(--carousel-dots-height) / 2);
    padding: 0 var(--carousel-dot-margin);

    [data-carousel-dots-track-container] {
        position: relative;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
    }

    [data-carousel-dots-track] {
        display: flex;
        align-items: center;
        position: absolute;
        inset-inline-start: 0;
        overflow: hidden;
    }

    [data-carousel-dot] {
        background-color: rgba(255, 255, 255, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        width: var(--carousel-dot-size);
        height: var(--carousel-dot-size);
        border-radius: calc(var(--carousel-dot-size) / 2);
        margin: var(--carousel-dot-margin);
        transition: all 200ms ease-in-out;

        &:where([data-small]) {
            width: var(--carousel-dot-size-small);
            height: var(--carousel-dot-size-small);
            margin: var(--carousel-dot-margin-small);
            border-radius: calc(var(--carousel-dot-size-small) / 2);
        }

        &:where([data-carousel-dot-indicator]) {
            background-color: #fff;
            z-index: 2;
            position: absolute;
            transition: none;
        }

        &:focus-visible {
            outline: solid 2px var(--hc-color-system-info-base);
        }
    }
`;
